import React, { useEffect, useState } from "react";

import "./HolePage.css";
import { holes } from "./CourseInfo";
import { db } from "./firebase";
import { Link, useHistory } from "react-router-dom";
import PlayerHole from "./PlayerHole";
import TeamScore from "./TeamScore";
import { useStateValue } from "./StateProvider";

function HolePage() {
  const history = useHistory();
  const [{ user }] = useStateValue();
  const [{ hole }, dispatch] = useStateValue();
  const [{ players }] = useStateValue();
  const [{ scores }] = useStateValue();
  const [{ overs }] = useStateValue();
  const [{ netovers }] = useStateValue();
  const [{ skins }, dispatch3] = useStateValue();
  const [{ eventDate }] = useStateValue();
  const [{ todaysEvent }] = useStateValue();
  const [{ teammatch }] = useStateValue();
  const [{ frontteam }, dispatch5] = useStateValue();
  const [{ backteam }, dispatch6] = useStateValue();
  const [, setLatitude] = useState("");
  const [, setLongitude] = useState("");
  const [{ location }, dispatch4] = useStateValue();
  const [{ isMonitored }] = useStateValue();
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [touchStartY, setTouchStartY] = useState(0);
  const [touchEndY, setTouchEndY] = useState(0);
  // const [distToFlag, setDistToFlag] = useState();

  useEffect(() => {
    localStorage.setItem("hole", JSON.stringify(hole));
  }, [hole]);

  useEffect(() => {
    findCoordinates();
    const d = new Date();
    const time =
      (d.getHours() < 10 ? "0" : "") +
      d.getHours() +
      ":" +
      (d.getMinutes() < 10 ? "0" : "") +
      d.getMinutes() +
      ":" +
      (d.getSeconds() < 10 ? "0" : "") +
      d.getSeconds();
    // console.log("Monitored", isMonitored);
    if (isMonitored === true) {
      // save scores if #scores for hole equals  # of players
      if (scores.filter((s) => s.hole === hole).length === players.length) {
        // console.log("All scores entered");
        const holescores = scores.filter((s) => s.hole === hole);
        console.log("scores", holescores);
        holescores.map((h) => {
          const result = players.find((p) => p.id === h.id);
          console.log("Result:", result);
          const overresult = overs.find(
            (p) => p.id === h.id && p.hole === h.hole
          );
          const netoverresult = netovers.find(
            (p) => p.id === h.id && p.hole === h.hole
          );
          console.log("Result:", result);
          result?.first &&
            db
              .collection("monitor")
              .doc(eventDate)
              .collection("scores")
              .doc(result.first)
              .update({
                ["scoring.H" + h.hole]: h.strokes,
                ["time.H" + h.hole]: time,
                ["over.H" + h.hole]: overresult.strokes,
                tfront: getTotal(getPlayerScoresF9(h.id)),
                tfrontover: getTotal(getPlayerOversF9(h.id)),
                tback: getTotal(getPlayerScoresB9(h.id)),
                tbackover: getTotal(getPlayerOversB9(h.id)),
                total18: getTotal(getPlayerScores18(h.id)),
                hole: hole,
              });
        });
      }
    }

    // if isLive is selected scores sent after every hole and location
    if (todaysEvent?.isLive === true) {
      // save scores if #scores for hole equals  # of players
      if (scores.filter((s) => s.hole === hole).length === players.length) {
        // console.log("All scores entered");
        const holescores = scores.filter((s) => s.hole === hole);
        // console.log(holescores);
        holescores.map((h) => {
          const result = players.find((p) => p.id === h.id);
          const overresult = overs.find(
            (p) => p.id === h.id && p.hole === h.hole
          );
          const netoverresult = netovers.find(
            (p) => p.id === h.id && p.hole === h.hole
          );

          result?.name &&
            db
              .collection("events")
              .doc(eventDate)
              .collection("scores")
              .doc(result.name)
              .update({
                scorer: user.uid,
                scorerName: user.displayName,
                scorerTime: time,
                scorerLocation: location,
                ["scoring.H" + h.hole]: h.strokes,
                ["time.H" + h.hole]: time,
                ["over.H" + h.hole]: overresult.strokes,
                ["netover.H" + h.hole]: netoverresult.strokes,
                tfront: getTotal(getPlayerScoresF9(h.id)),
                tfrontover: getTotal(getPlayerOversF9(h.id)),
                tfrontnetover: getTotal(getPlayerNetOversF9(h.id)),
                tback: getTotal(getPlayerScoresB9(h.id)),
                tbackover: getTotal(getPlayerOversB9(h.id)),
                tbacknetover: getTotal(getPlayerNetOversB9(h.id)),
                total18: getTotal(getPlayerScores18(h.id)),
                hole: hole,
              });
        });
      }
    }
    saveSkins();
    if (players.filter((s) => s.inTeam9 === true).length > 0) {
      getFrontWin();
      getBackWin();
    }
  }, [scores]);

  const findCoordinates = () => {
    let point;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          point = {
            lat: position.coords.latitude,
            long: position.coords.longitude,
          }; // example of point location

          //update State
          setLatitude(point.lat);
          setLongitude(point.long);
          //update State Provider
          dispatch4({
            type: "SAVELOCATION",
            location: {
              latitude: point.lat,
              longitude: point.long,
            },
          });
        },
        (error) => alert(error.message),
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
      );
    }
  };

  const getPlayerScoresF9 = (id) => {
    const playerscores = scores.filter((s) => s.id === id && s.hole <= 9);
    return playerscores;
  };
  const getPlayerOversF9 = (id) => {
    const playerscores = overs.filter((s) => s.id === id && s.hole <= 9);
    return playerscores;
  };
  const getPlayerNetOversF9 = (id) => {
    const playerscores = netovers.filter((s) => s.id === id && s.hole <= 9);
    return playerscores;
  };
  const getPlayerScoresB9 = (id) => {
    const playerscores = scores.filter((s) => s.id === id && s.hole >= 10);
    return playerscores;
  };
  const getPlayerOversB9 = (id) => {
    const playerscores = overs.filter((s) => s.id === id && s.hole >= 10);
    return playerscores;
  };
  const getPlayerNetOversB9 = (id) => {
    const playerscores = netovers.filter((s) => s.id === id && s.hole >= 10);
    return playerscores;
  };
  const getPlayerScores18 = (id) => {
    const playerscores = scores.filter((s) => s.id === id);
    return playerscores;
  };
  const getTotal = (selScores) => {
    if (!selScores.length == 0) {
      const Total = selScores?.reduce(
        (totalStrokes, score) => totalStrokes + score.strokes,
        0
      );
      return Total;
    } else {
      return "N/A";
    }
  };

  const nextHole = () => {
    console.log("Next");
    dispatch({
      type: "NEXTHOLE",
      num: { hole },
    });
  };

  const lastHole = () => {
    console.log("Last");
    dispatch({
      type: "LASTHOLE",
      num: { hole },
    });
  };
  function handleTouchStart(e) {
    // console.log("TouchStart", e);
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(e.targetTouches[0].clientX);
    setTouchStartY(e.targetTouches[0].clientY);
    setTouchStartY(e.targetTouches[0].clientY);
  }

  function handleTouchMove(e) {
    // console.log("End", e.targetTouches[0].clientX);
    setTouchEnd(e.targetTouches[0].clientX);
    setTouchEndY(e.targetTouches[0].clientY);
  }

  function handleTouchEnd() {
    const diff = touchStart - touchEnd;
    // do your stuff here for left swipe
    hole < 18 && diff > 150 && nextHole();
    // do your stuff here for right swipe
    hole !== 1 && diff < -150 && lastHole();
    // do your stuff here for down swipe
    touchStartY - touchEndY < -200 && history.push("/yardageslive");
  }

  // need to check for players in skins
  const saveSkins = () => {
    // save skin if #scores for hole equals  # of players
    if (scores.filter((s) => s.hole === hole).length === players.length) {
      //get players inskins
      const inSkinsPlayers = players.filter((p) => p.inGroupSkins === true);
      //get scores for current hole
      const scoring = scores.filter((s) => s.hole === hole);
      //get score where players are in skins
      const holeScores = scoring.filter((s) => {
        return inSkinsPlayers.some((p) => {
          return p.id === s.id && p.id === s.id;
        });
      });

      //sort hole scores from low to hi
      sort(holeScores);

      var amount = 0;
      var skinWinner = "";
      //  // with ties no one wins // declare winner
      if (holeScores.length > 1) {
        skinWinner =
          holeScores[0].strokes === holeScores[1].strokes
            ? "Carry Over"
            : holeScores[0].id;
        // console.log('win',holeScores[0].id)
        amount = holeScores[0].strokes < holeScores[1].strokes ? 1 : 0;
      }

      if (amount === 1) {
        //skin won on this hole
        if (holes[hole].par - holeScores[0].strokes > 0)
          amount = amount + holes[hole].par - holeScores[0].strokes; //change number of skins won for sub par holes
        // now add carryovers
        //  go backwards from present hole find last hole won (will need to calculate if starts on hole <>1)
        for (let i = hole - 1; i > 0; i--) {
          const carryOver = skins.find((s) => s.Hole === i);
          if (carryOver) {
            //if previous hole scores exist
            if (carryOver.Amount === 0) {
              // console.log("CarryOver", carryOver.Amount);
              amount = amount + 1;
            } else {
              break;
            }
          } else {
            break;
          }
        }
      }

      dispatch3({
        type: "SAVESKIN",
        skin: {
          Hole: hole,
          Winner: skinWinner,
          Amount: amount,
        },
      });
      // console.log("Skins", amount)
    }
  };

  const sort = (array) =>
    array.sort((a, b) => {
      return a.strokes - b.strokes;
    });

  const getFrontWin = () => {
    const frontNine = teammatch.filter((s) => s.hole <= 9);
    var frontTotal = frontNine?.reduce(
      (totalMatch, match) => totalMatch + match.result,
      0
    );
    const holesLeft = 9 - frontNine.length;
    const x = Math.abs(frontTotal) - holesLeft;

    if (x > 0) {
      const winTeam = frontTotal > 0 ? "Plus" : "Minus";
      // console.log(winTeam)
      dispatch5({
        type: "SAVEFRONTTEAM",
        frontteam: winTeam,
      });
    }
  };

  const getBackWin = () => {
    const backNine = teammatch.filter((s) => s.hole > 9);
    var backTotal = backNine?.reduce(
      (totalMatch, match) => totalMatch + match.result,
      0
    );
    const holesLeft = 9 - backNine.length;
    const x = Math.abs(backTotal) - holesLeft;

    if (x > 0) {
      const winTeam = backTotal > 0 ? "Plus" : "Minus";
      // console.log(winTeam)
      dispatch5({
        type: "SAVEBACKTEAM",
        backteam: winTeam,
      });
    }
  };

  // style= {{backgroundImage: `url(${holes[hole].img})` }}  //place in first div to get picture background

  return (
    <div
      className="holepage"
      onTouchStart={(e) => handleTouchStart(e)}
      onTouchMove={(e) => handleTouchMove(e)}
      onTouchEnd={handleTouchEnd}
    >
      <div className="holepage__title">
        <div className="holepage__topline">
          <div className="holepage__back">
            <span className="holepage__back" onClick={() => lastHole()}>
              {hole !== 1 ? "<<<<" : ""}
            </span>
          </div>

          <div>
            <Link to="/yardageslive" className="hole__number">
              <span className="hole__number">Hole #{hole}</span>
            </Link>
          </div>

          <div className="holepage__next">
            <span className="holepage__next" onClick={() => nextHole()}>
              {hole !== 18 ? ">>>>" : ""}
            </span>
          </div>
        </div>
        <div className="holepage__tables">
          <table className="holepage__yardages">
            <tbody>
              <tr>
                <th colSpan="3">Yardages </th>
              </tr>
              <tr>
                <td className="holepage__yardagesblue">{holes[hole].blue}</td>
                <td className="holepage__yardageswhite">{holes[hole].white}</td>
                <td className="holepage__yardagesgold">{holes[hole].gold}</td>
              </tr>
            </tbody>
          </table>

          <table className="holepage__info">
            <tbody>
              <tr>
                <th>PAR</th>
                <th colSpan="2">Rating</th>
              </tr>
              <tr>
                <td className="par">{holes[hole].par}</td>
                <td style={{ width: "20px", backgroundColor: "lightblue" }}>
                  {holes[hole].rating}
                </td>
                <td style={{ width: "20px", backgroundColor: "pink" }}>
                  {holes[hole].lrating}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="player__lines">
        <div className="player__lineitems">
          {players.map((player) => (
            <PlayerHole key={player.id} id={player.id} />
          ))}
        </div>
        <TeamScore />
      </div>
    </div>
  );
}

export default HolePage;
